module.exports = __webpack_public_path__ + "assets/img/701185fcf90e0f0a046f6ae29828acc2.png";